(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/satellite-filter.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/satellite-filter.js');
"use strict";


const _svs$ui$ReactDropdown = svs.ui.ReactDropdown,
  DropdownSelectItem = _svs$ui$ReactDropdown.DropdownSelectItem,
  DropdownItem = _svs$ui$ReactDropdown.DropdownItem,
  DropdownLabel = _svs$ui$ReactDropdown.DropdownLabel;
const SatelliteFilters = svs.poker_react.components.common.constants.SatelliteFilters;
const SatelliteFilter = _ref => {
  let setActiveSatelliteFilter = _ref.setActiveSatelliteFilter,
    activeSatelliteFilter = _ref.activeSatelliteFilter;
  return React.createElement("div", {
    className: "poker-filter-dropdown"
  }, React.createElement(DropdownSelectItem, {
    branding: "poker-react",
    onSelect: selected => setActiveSatelliteFilter(selected),
    selectLabel: "Turneringar",
    v2: true
  }, SatelliteFilters.map(option => React.createElement(DropdownItem, {
    key: option.label,
    name: option.value,
    selected: activeSatelliteFilter === option.value
  }, React.createElement(DropdownLabel, null, option.label)))));
};
setGlobal('svs.poker_react.components.upcomingEvents.SatelliteFilter', SatelliteFilter);

 })(window);